import { SharedModule } from '@app/shared/shared.module';
import { NgModule } from '@angular/core';

// Roteamento
import { FinanceiroRoutingModule } from './financeiro.routing';

// Componentes
import { ResumoFinanceiroComponent } from '@app/pages/financeiro/financeiro-resumo/resumo-financeiro.component';
import { PagarListaComponent } from '@app/pages/financeiro/pagar/pagar-lista/pagar-lista.component';
import { PagarFormComponent } from '@app/pages/financeiro/pagar/pagar-form/pagar-form.component';
import { ReceberListaComponent } from '@app/pages/financeiro/receber/receber-lista/receber-lista.component';
import { ReceberFormComponent } from '@app/pages/financeiro/receber/receber-form/receber-form.component';
import { LancamentoListaComponent } from '@app/pages/financeiro/lancamento/lancamento-lista/lancamento-lista.component';
import { LancamentoFormComponent } from '@app/pages/financeiro/lancamento/lancamento-form/lancamento-form.component';
import { ListaChequeComponent } from '@app/pages/financeiro/lista-cheque/lista-cheque.component';
import { ReciboComponent } from '@app/pages/financeiro/recibo/recibo.component';
import { ReciboMultiploComponent } from '@app/pages/financeiro/recibo-multiplo/recibo-multiplo.component';
import { BaixaComponent } from '@app/pages/financeiro/baixa/baixa.component';
import { TransferenciaFormComponent } from '@app/pages/financeiro/lancamento/transferencia-form/transferencia-form.component';
import { TextMaskModule } from 'angular2-text-mask';
import { CurrencyMaskConfig, CurrencyMaskModule, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { NotaFiscalListaComponent } from './nota-fiscal/nota-fiscal-lista/nota-fiscal-lista.component';
import { NotaFiscalFormComponent } from './nota-fiscal/nota-fiscal-form/nota-fiscal-form.component';
import { DivisaoHonorariosService } from '@app/services/divisao-honorarios.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { DivisaoHonorariosListaComponent } from './divisao-honorarios/divisao-honorarios-lista/divisao-honorarios-lista.component';
import { DivisaoHonorariosDetalharComponent } from './divisao-honorarios/divisao-honorarios-detalhar/divisao-honorarios-detalhar.component';
import { DivisaoHonorariosVincularComponent } from './divisao-honorarios/divisao-honorarios-vincular/divisao-honorarios-vincular.component';
import { RateioFormComponent } from './pagar/rateio-form/rateio-form.component';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: false,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.'
};
@NgModule({
  declarations: [
    ResumoFinanceiroComponent,
    PagarListaComponent,
    PagarFormComponent,
    ReceberListaComponent,
    ReceberFormComponent,
    LancamentoListaComponent,
    LancamentoFormComponent,
    ListaChequeComponent,
    ReciboComponent,
    ReciboMultiploComponent,
    BaixaComponent,
    TransferenciaFormComponent,
    NotaFiscalListaComponent,
    NotaFiscalFormComponent,
    DivisaoHonorariosListaComponent,
    DivisaoHonorariosDetalharComponent,
    DivisaoHonorariosVincularComponent,
    RateioFormComponent
  ],
  imports: [
    FinanceiroRoutingModule,
    SharedModule,
    TextMaskModule,
    CurrencyMaskModule,
    ReactiveFormsModule

  ],
  providers: [
    DivisaoHonorariosService,
    ToastrService,
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig,  }
  ]
})
export class FinanceiroModule { }
